<template>
    <section>
        {{$route.params}} <br>
        {{$route.query}}
    </section>
</template>

<script>
/**
 * 나의학습 다이나믹 링크 브릿지 컴포넌트(my learning dynamic link bridge component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import {dynamicMixin} from '@/mixins/dynamic.js'

export default {
    mixins: [dynamicMixin],
    async mounted() {
        this.$showLoading()

        // 브랜드 정보/언어 설정(set brand & language)
        await this.setBrandInfo()

        let loginPath = `/login?redirectPath=${encodeURIComponent(this.$route.path)}`

        //로그인 체크(check auth token)
        await this.checkLogin().then(() => {
            // move my learning
            this.$router.push({
                name: 'Learn',
                query: this.$route.query
            })
            
        }).catch(() => {
            // move sign in
            this.$router.push(loginPath)
        })
        
        setTimeout(() => {
            this.$hideLoading()
        }, 1000)

        
    },

    methods: {
        
    }
}
</script>